// generated by srcset-codegen
import src from "./the-newsletter-conference.png"
import src2x from "./the-newsletter-conference@2x.png"
import src3x from "./the-newsletter-conference@3x.png"

const width = 318
const height = 81
const srcSet = `${src2x} 2x, ${src3x} 3x`
export default { src, width, height, srcSet }
